module.exports = "<h1>Audiobooks not found</h1>\n<p>We cannot access audiobooks at this time. Please check your internet connection and try again.</p>\n"